"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesignerAlignTarget = void 0;
var _Containers = require("../Creator/Containers");
var _styles = require("@material-ui/core/styles");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _theme$orientation$po, _root;
  return {
    root: (_root = {
      marginTop: 46
    }, _defineProperty(_root, theme.breakpoints.down('xs'), {
      maxHeight: 'calc(100% - 216px)'
    }), _defineProperty(_root, theme.breakpoints.up('sm'), _defineProperty({}, theme.orientation.landscape, {
      marginTop: 0,
      maxHeight: 'calc(100% - 172px)'
    })), _defineProperty(_root, theme.orientation.landscape, {
      maxHeight: 'calc(100% - 136px)'
    }), _defineProperty(_root, theme.orientation.portrait, (_theme$orientation$po = {
      maxHeight: 'calc(100% - 216px)'
    }, _defineProperty(_theme$orientation$po, theme.breakpoints.up('sm'), {
      maxHeight: 'calc(100% - 216px)'
    }), _defineProperty(_theme$orientation$po, theme.breakpoints.up('md'), {
      maxHeight: 'calc(100% - 172px)',
      marginTop: 0
    }), _theme$orientation$po)), _defineProperty(_root, '@media (min-aspect-ratio: 13/9) and (min-height: 280px) and (max-width: 950px)', {
      maxHeight: '100%'
    }), _root)
  };
};
var DesignerAlignTarget = exports.DesignerAlignTarget = (0, _styles.withStyles)(styles, {
  name: 'DesignerAlignTarget'
})(_Containers.AlignTargetContainer);